export default {
  tagList: '/course/admin/tag/query/list',
  tagTypeFilter: '/course/admin/tag/type/select/box',
  tagStatusUpdate: '/course/admin/tag/change/status',
  tagListBatchDelete: '/course/admin/tag/batch/delete',
  tagInfoQuery: '/course/admin/tag/query',
  tagSave: '/course/admin/tag/create',
  tagUpdate: '/course/admin/tag/edit',
  tagListDelete: '/course/admin/tag/delete',

  //banner管理
  bannerList: '/course/admin/adbanner/query/list',
  bannerPlatformFilter: '/course/admin/adbanner/query/marks',
  bannerListDelete: '/course/admin/adbanner/delete',
  bannerStatusUpdate: '/course/admin/adbanner/change/status',
  bannerAdd: '/course/admin/adbanner/create',
  bannerInfo: '/course/admin/adbanner/query',
  bannerEdit: '/course/admin/adbanner/edit',

  //菜单管理
  menuList: '/security/identify/menu/query/page',
  menuListBatchDelete: '/security/identify/menu/batchDelete',
  menuListCreate: '/security/identify/menu/create',
  menuListUpdate: '/security/identify/menu/edit',
  menuQuery: '/security/identify/menu/query',
  systemMenuFilter: '/security/identify/menu/query/parent',
  systemMenuStatusUpdate: '/security/identify/menu/updateStatus',
}
